import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.ChangedBeneficiariesPopupContent',
    {
        title: 'Airwallex Batch Payment Check',
        description1: 'Following beneficiary details were edited in Airwallex during the request creation process:',
        description2: 'Last actual bank details from Airwallex will be applied to the request',
        cancel: 'Cancel',
        apply: 'Apply',
        beneficiary: 'Beneficiary',
        discrepancy: 'Discrepancy',
    }
);
